import React from 'react';
import GooglePlayButton from '../Button/GooglePlayButton';
import AppStoreButton from '../Button/AppStoreButton';

const DownloadItemsWrapper = ({ title }) => {
  return (
    <div className='download-modal-content-wrapper'>
      <h3 className={'download-modal-content-title'}>{title}</h3>
      <div className='download-modal-button-wrapper'>
        <div className='download-modal-button-group'>
          <GooglePlayButton buttonType={'white'} />
        </div>
        <div className='download-modal-button-group'>
          <AppStoreButton buttonType={'white'} />
        </div>
      </div>
    </div>
  );
};

export default DownloadItemsWrapper;
